import { amountToDisplayValue, Color, FontSize, SkeletonBox } from '@billy/design-system'
import React, { ReactElement } from 'react'
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Line,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { ChartDataKeys } from '../../enums/chartDataKeys'
import { ChartData } from '../../types/chartData'
import { generateBar, getOverviewChartGradient } from '../../utils'
import { CustomTooltip } from '../CustomTooltip'

interface OverviewChartProps {
  chartData: ChartData[]
  isLoading: boolean
}

export const OverviewChart = ({ isLoading, chartData }: OverviewChartProps): ReactElement => (
  <ResponsiveContainer height="100%" width="100%">
    {isLoading || chartData.length === 0 ? (
      <SkeletonBox />
    ) : (
      <ComposedChart barGap={2} data={chartData} margin={{ top: 0, left: 0, right: 0, bottom: -9 }} stackOffset="sign">
        {getOverviewChartGradient()}
        <XAxis
          axisLine={{ stroke: Color.Grey200 }}
          tickLine={{ stroke: Color.Grey200 }}
          dataKey="monthData.short"
          fontSize={FontSize.TextBodySM}
          label={{ fill: Color.Grey500 }}
          type="category"
        />
        <YAxis
          axisLine={{ stroke: Color.Grey200 }}
          tickLine={{ stroke: Color.Grey200 }}
          fontSize={FontSize.TextBodySM}
          label={{ fill: Color.Grey500 }}
          tickFormatter={(num) => amountToDisplayValue(num, true)}
          type="number"
        />
        <Area
          dataKey={ChartDataKeys.Result}
          fill="url(#gradient-lineShadow)"
          type="monotone"
          stroke={Color.Grey200}
          strokeWidth="1"
        />
        {generateBar(ChartDataKeys.Expenses)}
        {generateBar(ChartDataKeys.Revenue)}
        <Tooltip content={<CustomTooltip />} />
        <Line dataKey={ChartDataKeys.Result} stroke={Color.Grey200} strokeWidth="1" type="monotone" />
        <CartesianGrid stroke={Color.Grey200} strokeDasharray="1" vertical={false} />
        <ReferenceLine display="0" ifOverflow="visible" stroke={Color.Grey200} y={0} />
      </ComposedChart>
    )}
  </ResponsiveContainer>
)
